/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CoursePermission } from './CoursePermission';
const PatchRoleCourseDataParser = /* #__PURE__ */ parsers.object([['permission', CoursePermission], ['value', codecBoolean]]);
export class PatchRoleCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchRoleCourseDataParser.decode(input).map(res => new PatchRoleCourseData(res));
    }
    static unsafeDecode(input) {
        return PatchRoleCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchRoleCourseDataParser.encode(data);
    }
    static schema() {
        return PatchRoleCourseDataParser.schema();
    }
}
